import React, { Component } from 'react';

class DragAndDrop extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    drag: false
  }

  dropRef = React.createRef();

  handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  handleDragIn = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter++
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({drag: true})
    }
  }

  handleDragOut = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.setState({drag: false})
    }
  }

  handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({drag: false})
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const { accept } = this.props;
      let files = Array.from(e.dataTransfer.files);
      if (accept) {
        const acceptedExtensions = accept.split(',').map(t => t.trim().toLowerCase());
        files = files.filter(file => {
          const fileName = file.name.toLowerCase();
          const fileExtension = `.${fileName.split('.').pop()}`;
          return acceptedExtensions.includes(fileExtension);
        });
      }

      if (files.length > 0) {
        this.props.handleDrop(files);
      }
      
      e.dataTransfer.clearData()
      this.dragCounter = 0
    }
  }

  componentDidMount() {
    let div = this.dropRef.current
    div.addEventListener('dragenter', this.handleDragIn)
    div.addEventListener('dragleave', this.handleDragOut)
    div.addEventListener('dragover', this.handleDrag)
    div.addEventListener('drop', this.handleDrop)
  }

  componentWillUnmount() {
    let div = this.dropRef.current
    div.removeEventListener('dragenter', this.handleDragIn)
    div.removeEventListener('dragleave', this.handleDragOut)
    div.removeEventListener('dragover', this.handleDrag)
    div.removeEventListener('drop', this.handleDrop)
  }

  render() {
    return (
      <div className = {this.props.dragdrop} ref={this.dropRef} >
        {this.props.children}
      </div>
    )
  }
}
export default DragAndDrop;